<div
class="radiobuttons"
    [class.radiobuttons-notnewcomer]="!isNewcomer"
    [class.radiobuttons-newcomer]="isNewcomer" ><!-- main row for group of radio buttons  -->
    <div
        class="radiobutton label-container shadowNotSelected"
        [class.labelSelected]="productLevelPrice.ICurriculumProductLevel.ID == selectedProductLevelPriceID || (productLevelPrice.ICurriculumProductLevel.ID == 0 && selectedProductLevelPriceID == null)"
        [class.labelNotSelected]="productLevelPrice.ICurriculumProductLevel.ID != selectedProductLevelPriceID"
        [class.newComerRadiobutton]="isNewcomer"
        
        
        *ngFor="let productLevelPrice of productLevelPrices; let i = index" > <!-- each radio button -->
        
                <label 
                for="{{productLevelPrice.CurriculumProductLevelID}}"
                fxLayout="column" 
                id="p{{i}}"
                >     
                <div class="topTier" >
                    <b>{{productLevelPrice.ICurriculumProductLevel.Name}}</b>
                </div>
        
                <div class="midTier">
                    <b>{{productLevelPrice.DefaultPrice == 0 ? 'FREE' : productLevelPrice.DefaultPrice | numberToCurrency}}</b>
                </div>
        
                <div class="bottomTier" [innerHTML]="productLevelPrice.ICurriculumProductLevel.Description">
                    
                </div>
    
            </label>
        

    </div>

    
    <input type="radio"
    id="{{productLevelPrice.CurriculumProductLevelID}}"
    name="productLevels"
    [value]="productLevelPrice.ICurriculumProductLevel.ID" 
    [(ngModel)]="selectedProductLevelPriceID"
    (change)="productLevelChange(productLevelPrice)"
    *ngFor="let productLevelPrice of productLevelPrices">
    
</div> 



<div *ngIf="!priceInfoReceived" class="spinner-wrapper">
    <mat-spinner [diameter]="50" mode="indeterminate"></mat-spinner>
</div>